import * as React from "react";
import { twMerge } from "tailwind-merge";
import { SVGs } from "../assets";
import Text from "./Text";

export type InputContainerProps = {
  className?: string;
  label?: string;
  value?: string;
  placeholder?: string;
  children?: React.ReactNode;
  onClick?: () => void;
};

export default function PickerContainer({
  label,
  value,
  placeholder,
  className,
  children = null,
  onClick,
}: InputContainerProps) {
  const displayValue = value?.trim?.() ? value : undefined;
  return (
    <button
      onClick={onClick}
      type="button"
      aria-label={label}
      className={twMerge(
        "relative flex h-[56px] w-full items-center justify-between rounded-[4px] border border-border bg-transparent px-[15px] outline-none transition focus-visible:ring-2 focus-visible:ring-primary/25",
        className,
      )}
    >
      <Text
        level={5}
        className="bg-secondary px-[4px] text-text-surface absolute top-[-8px] left-[12px]"
      >
        {label}
      </Text>
      {children ?? (
        <>
          <Text
            className={twMerge(
              "text-text-surface",
              !displayValue && "font-thin",
            )}
          >
            {displayValue ?? placeholder ?? ""}
          </Text>
          <img
            src={SVGs.chevronDown}
            alt="Chevron down"
            className="w-[12.86px] mr-[4px]"
          />
        </>
      )}
    </button>
  );
}
